import { Button, Loader } from "@mantine/core";
import { ContextModalProps } from "@mantine/modals";
import { RichTextEditor } from "@mantine/tiptap";
import { Content, useEditor } from "@tiptap/react";
import { StarterKit } from "@tiptap/starter-kit";
import { useEffect } from "react";

import { useWindowLocationHost } from "@/hooks/useWindowLocationHost";
import { useGetCompanyByHostQuery, useLazyGetTermsUserByCompanyQuery } from "@/store/apis/nextcargo";
import "@mantine/tiptap/styles.css";

export type TermsModalProps = {
  title: string;
  terms: Content;
};

export function TermsModal({ context, id }: ContextModalProps<TermsModalProps>) {
  const { windowLocationHost } = useWindowLocationHost();

  const { data: company } = useGetCompanyByHostQuery({ host: windowLocationHost }, { skip: !windowLocationHost });
  const [getTermsTrigger, { data, isFetching }] = useLazyGetTermsUserByCompanyQuery();

  const editor = useEditor(
    {
      content: data?.content,
      extensions: [StarterKit],
      editable: false
    },
    [isFetching]
  );

  useEffect(() => {
    if (company?.id) {
      getTermsTrigger({ id: company.id });
    }
  }, [company]);

  return (
    <>
      <h1 className="mb-2 text-center text-2xl font-bold text-black">{data?.title}</h1>

      {!isFetching && (
        <RichTextEditor editor={editor}>
          <RichTextEditor.Content />
        </RichTextEditor>
      )}

      {isFetching && (
        <div className="my-4 flex items-center justify-center">
          <Loader size="xl" />
        </div>
      )}

      <Button onClick={() => context.closeModal(id)} color="primary" size="md" mt="md" fullWidth>
        Fechar
      </Button>
    </>
  );
}
